export const GeneralInformationMessageValidationConst = {
    campaignName: [
        { type: 'required', message: 'General Information is required' },
        { type: 'maxlength', message: 'Maximum character 100' },
    ],
    medium: [{ type: 'required', message: 'Channel is required' }],
};

export const GeneralInformationWAMessageValidationConst = {
    channel: [{ type: 'required', message: 'Message Type is required' }],
    from: [{ type: 'required', message: 'From is required' }],
    text: [
        { type: 'required', message: 'Text is required' },
        { type: 'maxlength', message: 'Maximum character 1024' },
    ],
    media: [{ type: 'required', message: 'Media Type is required' }],
    fileName: [{ type: 'required', message: 'File is required' }],
    template: [{ type: 'required', message: 'Template is required' }],
    category: [{ type: 'required', message: 'Category is required' }],
    catalogue: [{ type: 'required', message: 'Catalog is required' }],
    product: [{ type: 'required', message: 'Product is required' }],
    body: [{ type: 'maxlength', message: 'Maximum character 100' }],
    paramName: [{ type: 'required', message: 'Variable Name is required' }],
};

export const GeneralInformationEmailMessageValidationConst = {
    channel: [{ type: 'required', message: 'Message Type is required' }],
    from: [{ type: 'required', message: 'From is required' }],
    text: [{ type: 'required', message: 'Text is required' }],
    template: [{ type: 'required', message: 'Template is required' }],
};

export const GeneralInformationSMSMessageValidationConst = {
    channel: [{ type: 'required', message: 'Message Type is required' }],
    from: [{ type: 'required', message: 'From is required' }],
    text: [{ type: 'required', message: 'Text is required' }],
    template: [{ type: 'required', message: 'Template is required' }],
};

export const GeneralInformationLineMessageValidationConst = {
    channel: [{ type: 'required', message: 'Message Type is required' }],
    from: [{ type: 'required', message: 'From is required' }],
    text: [{ type: 'required', message: 'Text is required' }],
    template: [{ type: 'required', message: 'Template is required' }],
};

export const FailoverMechanismValidationConst = {
    interval: [
        { type: 'required', message: 'Interval Time is required' },
        {
            type: 'intervalTime',
            message: 'Must be greater than 0 and without decimal',
        },
    ],
    type: [{ type: 'required', message: 'Main Rules is required' }],
    accountId: [{ type: 'required', message: 'Account is required' }],
    subject: [{ type: 'required', message: 'Subject is required' }],
    message: [{ type: 'required', message: 'Message is required' }],
    templateName: [{ type: 'required', message: 'Template is required' }],
};

export const SchedulerMessageValidationConst = {
    startDate: [{ type: 'required', message: 'Select Date is required' }],
    startTime: [{ type: 'required', message: 'Select Time is required' }],
};
